import React from 'react';

const Logo = ({ size = 'md' }) => {
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-11 h-11',
    lg: 'w-14 h-14'
  };

  return (
    <div 
      className={`${sizeClasses[size]} rounded-full flex items-center justify-center relative overflow-hidden`}
      style={{ 
        backgroundColor: '#3EAE9C',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}
    >
      {/* Your processed Dolphin Power logo - now with transparent background and white dolphin */}
      <img 
        src="/assets/dolphin-logo-white.png"
        alt="Dolphin Power"
        className="w-[75%] h-[75%] object-contain"
        style={{
          transform: 'scale(1.15)'
        }}
      />
    </div>
  );
};

export default Logo;

